<template>
  <div>
    <url-monitor-stats-table />
  </div>
</template>

<script>
import UrlMonitorStatsTable from "@/components/web-perf/synthetic-monitoring/dashboard/UrlMonitorStatsTable.vue";

export default {
  name: "SyntheticMonitoringDashboard",
  components: {
    UrlMonitorStatsTable,
  },
};
</script>